(ns builder.builder.model
  (:require [re-frame.core :as rf]
            [builder.sdc.browser :as browser]
            [builder.index.model :as index]
            #?(:cljs ["lz-string" :refer [compressToEncodedURIComponent decompressFromEncodedURIComponent]])
            #?(:cljs [goog.crypt.base64 :as b64])
            #?(:cljs [goog.crypt :as crypt])
            #?(:cljs [goog.crypt.Sha256 :as sha256])
            #?(:cljs [goog.string :as gstring])))

(rf/reg-sub
 ::form-id
 (fn [db _]
   (get-in db [:fragment-params :q-id])))

(rf/reg-sub
 ::questionnaire-data
 (fn [db _]
   (get-in db [:fragment-params :params :q-data])))

(rf/reg-sub
 ::aidbox-portal-token
 (fn [db _]
   (get-in db [::db :aidbox-portal-token])))

;; (rf/reg-sub
;;  ::questionnaire-data
;;  (fn [db _]
;;    (when-let [q (get-in db [:questionnaire])]
;;      #?(:cljs (compressToEncodedURIComponent (js/JSON.stringify (clj->js q)))))

;;    )
;;  )

(defn code-verifier
  []
  (let [length (+ 43 (rand-int 85)) ;; length should be between 43 and 128
        charset "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"]
    (apply str (take length (repeatedly #(nth charset (rand-int (count charset))))))))

(defn sha256-hash-base64-urlsafe
  "Compute the SHA256 hash of a given string and return it as a base64 URL-safe encoded string"
  [s]
  #?(:cljs (let [sha256 (goog.crypt.Sha256.)
                 s-bytes (goog.crypt/stringToUtf8ByteArray s)]
             (.update sha256 s-bytes)
             (-> (.digest sha256)
                 (goog.crypt.base64/encodeByteArray goog.crypt.base64.Alphabet.WEBSAFE_NO_PADDING)))
     :clj nil))

(rf/reg-event-fx
 ::handle-message
 (fn [{db :db} [_ message]]
   (cond (= (:type message) "from-aidbox-forms/authorize")
         (let [code-verifier (code-verifier)]
           {:zframes.redirect/page-redirect {:uri #?(:cljs (gstring/format "%s/ui/portal" index/PORTAL_BASE_URL)
                                                     :clj (format "%s/ui/portal" index/PORTAL_BASE_URL))
                                             :params {:response_type "code"
                                                      :client_id "public-builder-client"
                                                      :code_challenge (sha256-hash-base64-urlsafe code-verifier)
                                                      :code_challenge_method "S256"
                                                      :redirect_uri index/AUTH_REDIRECT_URL}}
            :storage/set {:code-verifier code-verifier
                          :authorize-from "builder"}})

         (= (:type message) "sdc.aidbox.persistQuestionnaire")
         (let [data #?(:cljs (compressToEncodedURIComponent (js/JSON.stringify (clj->js (:data message))))
                       :clj nil)]
           {:db (assoc-in db [:questionnaire] (:data message))
            :zframes.redirect/redirect {:uri (str "/builder?q-data=" data)}
            :dispatch-later {:ms 100 :dispatch [:zframes.redirect/refresh-page]}}))))

(rf/reg-event-fx
 ::sync-builder-config
 (fn [_ _]
   {:browser/post-iframe-message {:iframe-id "builder-frame"
                                  :messages [{:type "sdc.configure"
                                              :data {:configuration {:builder {:hide-publish true
                                                                               :hide-back-button true
                                                                               :hide-save-theme true
                                                                               :highlight-download-button true
                                                                               :hide-convert true
                                                                               :disable-submit-button true
                                                                               :enable-share true
                                                                               :disabled-save true
                                                                               :builder/enable-external-renderers true
                                                                               }
                                                                     :enable-internal-completion true
                                                                     :enable-anonymous true
                                                                     :disable-load-sdc-config true
                                                                     :enable-post-message true
                                                                     }}}]}}
   )

 )


(rf/reg-event-fx
 ::ctx
 [(rf/inject-cofx :zframes.cookies/get :aidbox-token)]
 (fn [{db :db {aidbox-token :aidbox-token} :cookie} [_ phase params]]
   (cond
     (= phase :init)
     (if aidbox-token
       {:browser/listen-post-message [::handle-message]
        :dispatch [:browser/post-message]
        :db (assoc-in db [::db :aidbox-portal-token] aidbox-token)}
       (cond-> {:route-map/redirect "/"
                :dispatch [::index/trigger-authorization
                           (if (:q-id params) "open-questionnaire" "builder")]}
         (:q-id params)
         (assoc :storage/set {:pending-questionnaire {:id (:q-id params)}})))

     (= phase :deinit)
     {:db (dissoc db ::db)})))
